class BranchAPI {

    static all (slugs) {

        let url = `/wp-json/wp/v2/branches`

        // when we want to fetch only certain branches
        if (slugs) {
            let cleanSlugs = slugs.replace(/\s+/g, '') //remove all whitespace
            url = `/wp-json/wp/v2/branches?slug=${cleanSlugs}`
        }

        return fetch(url, {
            credentials: 'same-origin',
        }).then(this.handleStatus)
    }

    static handleStatus (response) {
        if (!response.ok) {
            // Fetch doesn't reject on HTTP error status
            throw Error(`Request rejected with status ${response.status}`)
        }
        return response
    }

}

export default BranchAPI

// WEBPACK FOOTER //
// ./src/js/projects/api/BranchAPI.js
